// extracted by mini-css-extract-plugin
export default {"wrapper":"EditAccountForm_wrapper__WPZ35","submitWrapper":"EditAccountForm_submitWrapper__Pfful"};